import * as tslib_1 from "tslib";
import { OnInit, ErrorHandler } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { AuthService } from '../../auth/auth/auth.service';
import { UserService } from '../user/user.service';
import { AirportService } from '../../airport/airport.service';
var ReviewMoveComponent = /** @class */ (function () {
    function ReviewMoveComponent(dialogRef, data, _auth, _userService, _errorHandler, _snackBar, _airportService) {
        this.dialogRef = dialogRef;
        this._auth = _auth;
        this._userService = _userService;
        this._errorHandler = _errorHandler;
        this._snackBar = _snackBar;
        this._airportService = _airportService;
        this.selectedEntityType = null;
        this.selectedEntity = null;
        this.origType = data.entityType;
        this.origEntity = data.entityId;
        this.reviewId = data.reviewId;
    }
    ReviewMoveComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.dialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
        this.formGroup = new FormGroup({
            entity_id: new FormControl(this.selectedEntity, [Validators.required, Validators.maxLength(4)]),
            type: new FormControl(this.selectedEntityType, [Validators.required])
        });
    };
    ReviewMoveComponent.prototype.submitForm = function () {
        this.moveReview();
        // this.dialogRef.close();
    };
    ReviewMoveComponent.prototype.moveReview = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var snackBarOpts, newEntity, airportResponse, response, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._auth.authenticated || !this._auth.endUser) {
                            this._auth.redirectToLogin();
                            return [2 /*return*/];
                        }
                        snackBarOpts = { duration: 2000 };
                        if (!this.selectedEntityType) {
                            this._snackBar.open("Entity type required.", 'Dismiss', { duration: 5000 });
                            return [2 /*return*/];
                            // this.currentReview.rating = null;
                        }
                        if (!this.selectedEntity) {
                            this._snackBar.open("Entity Id required.", 'Dismiss', { duration: 5000 });
                            return [2 /*return*/];
                            // this.currentReview.rating = null;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        newEntity = void 0;
                        if (!(this.selectedEntityType === 'Airport')) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._airportService.getAirport(this.selectedEntity, true)];
                    case 2:
                        airportResponse = _a.sent();
                        if (airportResponse.airportId) {
                            newEntity = airportResponse.airportId;
                        }
                        else {
                            this._snackBar.open('Invalid airport identifier.', 'Dismiss', { duration: 6000 });
                            return [2 /*return*/];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        newEntity = Number(this.selectedEntity);
                        _a.label = 4;
                    case 4: return [4 /*yield*/, this._userService.moveReview(this.origType, this.origEntity, this.selectedEntityType, newEntity, this.reviewId)];
                    case 5:
                        response = _a.sent();
                        if (response.errorMessage) {
                            this._snackBar.open(response.errorMessage, 'Dismiss', { duration: 6000 });
                            return [2 /*return*/];
                        }
                        this._snackBar.open("Review moved.", 'Dismiss', snackBarOpts);
                        this.dialogRef.close({ success: true });
                        return [3 /*break*/, 7];
                    case 6:
                        e_1 = _a.sent();
                        this._snackBar.open('An error occurred moving the review. Please try again later.', 'Dismiss', snackBarOpts);
                        this._errorHandler.handleError(e_1);
                        // Set state to error, then reset after a few seconds to allow retry.
                        this.dialogRef.close({ success: true });
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * triggered by cancel button click event
     */
    ReviewMoveComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    /**
     * closes modal
     * @param data
     */
    ReviewMoveComponent.prototype.close = function (data) {
        this.dialogRef.close(data);
    };
    return ReviewMoveComponent;
}());
export { ReviewMoveComponent };
